'use strict';

import { Injectable } from '@angular/core';

const APP_PREFIX = 'Biohackk-';

const isJSON = (str: any) => {
  try {
      const obj = JSON.parse(str);
      if (obj && typeof obj === 'object' && obj !== null) {
          return true;
      }
  } catch (err) {}
  return false;
};

@Injectable({providedIn: 'root'})
export class LocalStorageService {
  static loadInitialState() {
    return Object.keys(localStorage).reduce((state: any, storageKey) => {
      if (storageKey.includes(APP_PREFIX)) {
        const stateKeys = storageKey
          .replace(APP_PREFIX, '')
          .toLowerCase()
          .split('.')
          .map(key =>
            key
              .split('-')
              .map(
                (token, index) =>
                  index === 0
                    ? token
                    : token.charAt(0).toUpperCase() + token.slice(1)
              )
              .join('')
          );
        let currentStateRef = state;
        stateKeys.forEach((key, index) => {
          if (index === stateKeys.length - 1) {
            currentStateRef[key] = JSON.parse(localStorage.getItem(storageKey) || '');
            return;
          }
          currentStateRef[key] = currentStateRef[key] || {};
          currentStateRef = currentStateRef[key];
        });
      }
      return state;
    }, {});
  }

  setItem(key: string, value: any): void {
    // console.log('Setting item in local storage', `${APP_PREFIX}${key}`, value);
    if (typeof value === 'string') {
      localStorage.setItem(`${APP_PREFIX}${key}`, value);
    } else if (value && typeof value === 'object') {
      // console.log('Adding item to local storage', `${APP_PREFIX}${key}`, JSON.stringify(value));
      localStorage.setItem(`${APP_PREFIX}${key}`, JSON.stringify(value));
    }
  }

  getItem(key: string): string | null {
    const item = localStorage.getItem(`${APP_PREFIX}${key}`) || null;
    if (item && isJSON(item)) {
      return JSON.parse(item);
    } else if (typeof item === 'string') {
      return item;
    } else {
      return item;
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(`${APP_PREFIX}${key}`);
  }
}
